import './styles.css';

function Header() {
  return (
    <header className="main-header-container">
      <h1 className="main-header-title">DS Sales</h1>
    </header>
  );
}

export default Header;
